/**
 * Formats a listing address for cards (e.g. browse): "City, ST".
 * Expects strings like "Cambridge, MA" or "Boston, MA, USA".
 */
export function formatCityState(addr: unknown): string | null {
  if (typeof addr !== "string" || !addr.trim()) return null;
  const parts = addr.split(",").map(p => p.trim()).filter(Boolean);
  if (parts.length >= 2) {
    const city = parts[0];
    const region = parts[1];
    const stateToken = region.split(/\s+/)[0];
    if (/^[A-Za-z]{2}$/.test(stateToken)) {
      return `${city}, ${stateToken.toUpperCase()}`;
    }
    return `${city}, ${region}`;
  }
  return parts[0] ?? null;
}
